import React, { useEffect, useState } from 'react';
import PageTop from '@root/modules/Sellers/Dashboard/components/PageTop/index';
import { Card } from 'antd';
import { Header } from 'antd/lib/layout/layout';
import useTranslate from '@root/core/hooks/useTranslate';
import BreadcrumbList from '@root/modules/Sellers/Stock/components/Breadcrumb';
import DeliveryList from '../components/DeliveryList';
import deliveryService from '@root/modules/Warehouse/Delivery/services/delivery';
import { useParams } from 'react-router-dom';

const breadcrumbList = [
  {
    tittle: 'Delivery',
    url: ''
  },
  {
    tittle: 'Delivery List',
    url: ''
  }
];
const DeliveryHome = () => {
  const [t] = useTranslate();

  return (
    <>
      {/* <Header className="header-page-top">
        <PageTop breadcrumbList={breadcrumbList} title="Delivery" t={t} />
      </Header> */}
      <BreadcrumbList listBreadcrumb={breadcrumbList} />

      <div className="admin-container ">
        <Card
          bordered={false}
          className="admin-card"
          style={{
            minHeight: '80vh',
            background: 'none'
          }}
        >
          <DeliveryList />
        </Card>
      </div>
    </>
  );
};

export default DeliveryHome;
